import * as actionTypes from './actionTypes';

/*------------------------------------------------------------------------------------------------*/
/* Third Party Integrations Fetch Actions                                                         */
/*------------------------------------------------------------------------------------------------*/
export const fetchThirdPartyIntegrationsRequest = () => ({
  type: actionTypes.FETCH_INTEGRATIONS_REQUEST,
});

/**
 * fetchThirdPartyIntegrationsError
 * Fetch third party integrations request error action.
 * @param { String } error: The request error.
 * @returns { Object } action.
 */
export const fetchThirdPartyIntegrationsError = (error /*: string */) => ({
  type: actionTypes.FETCH_INTEGRATIONS_ERROR,
  error,
});

/**
 * fetchThirdPartyIntegrationsResponse
 * Fetch third party integrations response action.
 * @param { Object } response: The fetch response.
 * @returns { Object } action.
 */
export const fetchThirdPartyIntegrationsResponse = (integrations) => ({
  type: actionTypes.FETCH_INTEGRATIONS_RESPONSE,
  integrations,
});

/*------------------------------------------------------------------------------------------------*/
/* Integrations Delete Actions                                                                    */
/*------------------------------------------------------------------------------------------------*/

export const removeIntegrationRequest = (
  integrationId /*: number */,
  integrationName /*: string */,
) => ({
  type: actionTypes.REMOVE_INTEGRATION_REQUEST,
  integrationId,
  integrationName,
});

export const removeIntegrationError = (error /*: string */) => ({
  type: actionTypes.REMOVE_INTEGRATION_ERROR,
  error,
});

export const removeIntegrationResponse = (integrationId /*: number */) => ({
  type: actionTypes.REMOVE_INTEGRATION_RESPONSE,
  integrationId,
});
